import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  isPasswordReset
  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activeRouter.queryParams.subscribe(param => {
      this.isPasswordReset = param.isresetPassword == undefined ? true : false;
    })
  }

}
